var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BookmarkModel } from 'src/app/bookmarks/models/bookmark.model';
import { Store, Select, Actions, ofActionDispatched } from '@ngxs/store';
import { SetPublishDimensions, GetPublishIFrame, GetPublishURL, GetPublishURLSuccess, GetPublishIFrameSuccess, GetPublishURLFail, GetPublishIFrameFail, SetPublishing, GetPublishImageCode, GetPublishImageCodeSuccess, GetPublishImageCodeFail, SavePublishImage, SavePublishImageSuccess, SavePublishImageFail } from '../../state/publish.actions';
import { PublishState } from '../../state/publish.state';
import { Observable, Subject, of } from 'rxjs';
import { WidgetOptions } from '../../models/widget-options.model';
import { FormBuilder, Validators } from '@angular/forms';
import { debounceTime, takeUntil, flatMap } from 'rxjs/operators';
import { OrganizationsState } from 'src/app/organizations/state/organizations.state';
import { PublishService } from '../../publish.service';
import { StorageService, StorageItemEnum } from 'src/app/shared/storage.service';
import { AuthState } from 'src/app/auth/state/auth/auth.state';
import { ClipboardService } from 'src/app/shared/clipboard.service';
import { DialogService } from 'src/app/dialogs/dialog.service';
import { PublishWidgetComponent } from '../publish-widget/publish-widget.component';
import { ImageTypeEnum } from 'src/app/shared/image.service';
import { BackgroundModel } from 'src/app/engine/models/background.model';
import { get } from 'lodash';
import { invalidateLocalWidgetOptions } from 'src/app/shared/storage-utils';
const snapshotSmall = {
    'title': 'Small',
    'type': 'desktop',
    'dimensions': {
        'width': 480,
        'height': 320
    },
    'orientation': 'horizontal'
};
const snapshotMedium = {
    'title': 'Medium',
    'type': 'desktop',
    'dimensions': {
        'width': 700,
        'height': 550
    },
    'orientation': 'horizontal'
};
const snapshotLarge = {
    'title': 'Large',
    'type': 'desktop',
    'dimensions': {
        'width': 1920,
        'height': 1200
    },
    'orientation': 'horizontal'
};
const snapshotMax = {
    'title': 'Maximum',
    'type': 'desktop',
    'dimensions': {
        'width': 2560,
        'height': 1440
    },
    'orientation': 'horizontal'
};
export class PublishComponent {
    constructor(store, actions, publishService, storageService, clipboardService, dialogService, snackBar, fb, ref) {
        this.store = store;
        this.actions = actions;
        this.publishService = publishService;
        this.storageService = storageService;
        this.clipboardService = clipboardService;
        this.dialogService = dialogService;
        this.snackBar = snackBar;
        this.fb = fb;
        this.ref = ref;
        // snapshot state
        this.minSnapshotDimensions = {
            width: 300,
            height: 300
        };
        this.maxSnapshotDimensions = {
            width: 2560,
            height: 1440
        };
        this.snapshotSizes = [snapshotSmall, snapshotMedium, snapshotLarge, snapshotMax];
        this.selectedSnapshotSize = snapshotMedium;
        this.ngUnsubscribe = new Subject();
        // optional: default options
        this.defaultWidgetOptions = Object.assign({}, new WidgetOptions(), { loadRotate: 10 });
        const widgetOptions = this.getWidgetOptions();
        const dimensions = this.store.selectSnapshot(PublishState.getDimensions);
        const minDimensions = this.store.selectSnapshot(PublishState.getMinDimensions);
        const { button, handHint, play } = widgetOptions.initial;
        const { alert, overlay } = widgetOptions.disableScroll;
        // mode selection form
        this.formModeGroup = this.fb.group({
            mode: ['3d', Validators.required]
        });
        // snapshot form
        const snapshotDimensions = this.selectedSnapshotSize.dimensions;
        this.formSnapshot = this.fb.group({
            dimensions: this.fb.group({
                width: [
                    snapshotDimensions.width,
                    [Validators.required, Validators.min(this.minSnapshotDimensions.width), Validators.max(this.maxSnapshotDimensions.width)]
                ],
                height: [
                    snapshotDimensions.height,
                    [Validators.required, Validators.min(this.minSnapshotDimensions.height), Validators.max(this.maxSnapshotDimensions.height)]
                ]
            })
        });
        // widget 3D form
        this.form = this.fb.group({
            dimensions: this.fb.group({
                width: [dimensions.width, [Validators.min(minDimensions.width)]],
                height: [dimensions.height, [Validators.min(minDimensions.height)]]
            }),
            options: this.fb.group(widgetOptions),
            rotate: this.fb.group({
                enabled: widgetOptions.loadRotate !== null,
                value: widgetOptions.loadRotate
            }),
            initial: this.fb.group({
                enabled: button || handHint || play,
                mode: button ? 'button' : handHint ? 'handHint' ? play : 'play' : ''
            }),
            disableScroll: this.fb.group({
                enabled: alert || overlay,
                mode: alert ? 'alert' : (overlay ? 'overlay' : '')
            })
        });
        // set color
        const colors = get(widgetOptions, 'background.colors');
        if (colors) {
            const color = {
                red: colors[0],
                green: colors[1],
                blue: colors[2],
                alpha: colors.length > 3 ? colors[3] : 1
            };
            this.bgColor = this.getBackgroundFromColor(color);
        }
        // subscribe to url/code generation
        this.actions
            .pipe(ofActionDispatched(GetPublishURLSuccess), flatMap((response) => this.copyToClipboard(response.url)), takeUntil(this.ngUnsubscribe))
            .subscribe((copied) => {
            this.snackBar.open(copied ? 'Successfully copied URL to clipboard.' : 'Unable to copy URL to clipboard.');
        });
        this.actions
            .pipe(ofActionDispatched(GetPublishURLFail), takeUntil(this.ngUnsubscribe))
            .subscribe(() => {
            this.snackBar.open(`Unable to generate URL.`);
        });
        this.actions
            .pipe(ofActionDispatched(GetPublishIFrameSuccess), flatMap((response) => this.copyToClipboard(response.embed)), takeUntil(this.ngUnsubscribe))
            .subscribe((copied) => {
            this.snackBar.open(copied ? 'Successfully copied embed code to clipboard.' : 'Unable to copy embed code to clipboard.');
        });
        this.actions
            .pipe(ofActionDispatched(GetPublishIFrameFail), takeUntil(this.ngUnsubscribe))
            .subscribe(() => {
            this.snackBar.open(`Unable to generate embed code.`);
        });
        // generate image url
        this.actions
            .pipe(ofActionDispatched(SavePublishImageSuccess), flatMap((response) => this.copyToClipboard(response.imageURL)), takeUntil(this.ngUnsubscribe))
            .subscribe((copied) => {
            this.snackBar.open(copied ? 'Successfully copied image URL to clipboard.' : 'Unable to copy image URL to clipboard.');
        });
        this.actions
            .pipe(ofActionDispatched(SavePublishImageFail), takeUntil(this.ngUnsubscribe))
            .subscribe(() => {
            this.snackBar.open(`Unable to generate image URL.`);
        });
        // generate image code
        this.actions
            .pipe(ofActionDispatched(GetPublishImageCodeSuccess), flatMap((response) => this.copyToClipboard(response.embed)), takeUntil(this.ngUnsubscribe))
            .subscribe((copied) => {
            this.snackBar.open(copied ? 'Successfully copied image embed code to clipboard.' : 'Unable to copy image embed code to clipboard.');
        });
        this.actions
            .pipe(ofActionDispatched(GetPublishImageCodeFail), takeUntil(this.ngUnsubscribe))
            .subscribe(() => {
            this.snackBar.open(`Unable to generate embed code.`);
        });
    }
    get widgetOptions() {
        return this.mode === '2d' ? null : this.form.value.options;
    }
    get rotateEnabled() {
        const rotate = this.form.get('rotate').value;
        return rotate.enabled;
    }
    get mode() {
        return this.formModeGroup.get('mode').value;
    }
    get widgetWidth() {
        if (this.mode === '2d') {
            return this.selectedSnapshotSize.dimensions.width;
        }
        else {
            return this.store.selectSnapshot(PublishState.getDimensions).width;
        }
    }
    get widgetHeight() {
        if (this.mode === '2d') {
            return this.selectedSnapshotSize.dimensions.height;
        }
        else {
            return this.store.selectSnapshot(PublishState.getDimensions).height;
        }
    }
    get widgetBGColor() {
        if (this.mode === '2d') {
            return this.snapshotBGColor;
        }
        else {
            return this.bgColor;
        }
    }
    get widgetScalable() {
        return this.mode === '2d';
    }
    ngOnInit() {
        this.setupWidgetForm();
        this.setupSnapshotForm();
        this.store.dispatch(new SetPublishing(true));
    }
    ngOnDestroy() {
        this.store.dispatch(new SetPublishing(false));
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    setupWidgetForm() {
        const optionsGroup = this.form.get('options');
        const dimensionsGroup = this.form.get('dimensions');
        const rotateGroup = this.form.get('rotate');
        const initialGroup = this.form.get('initial');
        const disableScrollGroup = this.form.get('disableScroll');
        // rotate params
        const rotateEnabledField = rotateGroup.get('enabled');
        const rotateValueField = rotateGroup.get('value');
        // set rotate defaults when toggling rotate enabled
        rotateEnabledField.valueChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((enabled) => {
            if (enabled) { // set default widget rotate
                const rotateValue = typeof (rotateValueField.value) === 'number' ? rotateValueField.value : this.defaultWidgetOptions.loadRotate;
                rotateValueField.patchValue(rotateValue);
            }
            else { // reset widget rotate
                optionsGroup.patchValue({
                    loadRotate: null
                });
            }
        });
        // push rotate changes to widget options
        rotateValueField.valueChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((value) => {
            optionsGroup.patchValue({
                loadRotate: value
            });
        });
        // sync initial params
        initialGroup.get('enabled').valueChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((enabled) => {
            initialGroup.patchValue({
                mode: enabled ? 'button' : ''
            });
        });
        initialGroup.get('mode').valueChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((mode) => {
            initialGroup.patchValue({ enabled: !!mode }, { emitEvent: false });
            optionsGroup.patchValue({
                initial: {
                    button: mode === 'button',
                    handHint: mode === 'handHint',
                    play: mode === 'play'
                }
            });
        });
        // sync scroll params
        disableScrollGroup.get('enabled').valueChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((enabled) => {
            disableScrollGroup.patchValue({
                mode: enabled ? 'alert' : ''
            });
        });
        disableScrollGroup.get('mode').valueChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((mode) => {
            disableScrollGroup.patchValue({ enabled: !!mode }, { emitEvent: false });
            optionsGroup.patchValue({
                disableScroll: {
                    alert: mode === 'alert',
                    overlay: mode === 'overlay'
                }
            });
        });
        // sync dimensions
        dimensionsGroup.valueChanges
            .pipe(debounceTime(300), takeUntil(this.ngUnsubscribe))
            .subscribe((dimensions) => {
            this.setScreenDimensions(dimensions);
        });
        this.dimensions$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((dimensions) => {
            dimensionsGroup.setValue(dimensions, { emitEvent: false });
        });
        optionsGroup.valueChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((options) => {
            // persist options
            this.writeSavedOptions(options);
        });
    }
    setupSnapshotForm() {
        const formSnapshotDimensions = this.formSnapshot.get('dimensions');
        formSnapshotDimensions.valueChanges
            .pipe(debounceTime(500), takeUntil(this.ngUnsubscribe))
            .subscribe(() => {
            // validation
            const { width, height } = formSnapshotDimensions.value;
            if (formSnapshotDimensions.valid) {
                // find target dimensions or custom
                const foundSnap = this.snapshotSizes.find((snap) => snap.dimensions.width === width && snap.dimensions.height === height);
                this.selectedSnapshotSize = Object.assign({}, this.selectedSnapshotSize, { title: foundSnap ? foundSnap.title : 'Custom', dimensions: {
                        width,
                        height
                    } });
                // mark changes
                this.ref.markForCheck();
            }
        });
    }
    setScreenDimensions(dimensions) {
        this.store.dispatch(new SetPublishDimensions(dimensions));
    }
    handleGenerateIFrame() {
        this.generateIFrameCode();
    }
    handleGenerateURL() {
        this.generateURL();
    }
    handleCopyImageURL() {
        this.generateImageURL();
    }
    handleGenerateImage() {
        this.generateImageCode();
    }
    generateIFrameCode() {
        const widgetOptions = this.form.value.options;
        this.store.dispatch(new GetPublishIFrame(this.model, widgetOptions, this.camera));
    }
    generateURL() {
        const widgetOptions = this.form.value.options;
        this.store.dispatch(new GetPublishURL(this.model, widgetOptions, this.camera));
    }
    generateImageURL() {
        this.publishWidget.takeSnapshot()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((imageData) => {
            this.store.dispatch(new SavePublishImage(imageData));
        });
    }
    generateImageCode() {
        this.publishWidget.takeSnapshot()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((imageData) => {
            const widgetOptions = new WidgetOptions(); // use default options
            this.store.dispatch(new GetPublishImageCode(this.model, imageData, widgetOptions, this.camera));
        });
    }
    handleSnapshotBGColorClick(color) {
        this.snapshotBGColor = this.getBackgroundFromColor(color);
    }
    handleSnapshotSizeClick(screen) {
        this.selectedSnapshotSize = Object.assign({}, screen);
        this.formSnapshot.patchValue({
            dimensions: Object.assign({}, screen.dimensions)
        });
    }
    handleDownloadSnapClick() {
        this.publishWidget.takeSnapshot()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((imageData) => {
            this.downloadImage(imageData);
        });
    }
    handleCameraUpdated(camera) {
        this.camera = camera;
    }
    copyToClipboard(copyText) {
        return this.clipboardService.copyToClipboard(copyText)
            .pipe(flatMap((copied) => {
            if (copied) {
                return of(copied);
            }
            else {
                return this.dialogService.openClipboardDialog(copyText)
                    .afterClosed();
            }
        }));
    }
    formatScreenSizeText(screen) {
        const { title, dimensions } = screen;
        return `${title} (${dimensions.width} x ${dimensions.height})`;
    }
    getBackgroundFromColor(color) {
        const colors = color ? [color.red, color.green, color.blue, color.alpha] : null;
        if (colors) {
            return new BackgroundModel([...colors, ...colors], 'radial', [0, 100]);
        }
        else {
            return null;
        }
    }
    getWidgetOptions() {
        // read persisted options
        const storedOptions = this.readSavedOptions();
        // read organization settings
        const orgWidgetOptions = this.store.selectSnapshot(OrganizationsState.getWidgetOptions);
        // apply saved settings
        if (storedOptions) {
            const userOptions = this.publishService.extendWidgetOptions(new WidgetOptions(), storedOptions);
            return Object.assign({}, userOptions, { 
                // !important: disable user background, expect from organization
                background: orgWidgetOptions ? orgWidgetOptions.background : null });
        }
        else {
            return orgWidgetOptions || new WidgetOptions();
        }
    }
    readSavedOptions() {
        // invalidate widget options in local storage created before 
        // Wed Nov 13 2019 14:57:47 GMT-0500 (Eastern Standard Time)
        const invalidateBefore = 1573675067505;
        const userProfileId = this.getStorageKey();
        invalidateLocalWidgetOptions(userProfileId, invalidateBefore);
        // read persisted options
        const storedOptions = this.storageService.getLocalJSON(StorageItemEnum.WidgetOptions);
        if (storedOptions) {
            const key = this.getStorageKey();
            return storedOptions[key];
        }
        else {
            return null;
        }
    }
    writeSavedOptions(options) {
        // patch options with a timestamp
        const optionsWithTimestamp = Object.assign({}, options, { timestamp: Date.now() });
        // modify existing entry
        const storedOptions = this.storageService.getLocalJSON(StorageItemEnum.WidgetOptions) || {};
        const key = this.getStorageKey();
        storedOptions[key] = optionsWithTimestamp;
        this.storageService.setLocalItem(StorageItemEnum.WidgetOptions, storedOptions);
    }
    // get unique key for widget settings
    getStorageKey() {
        return this.store.selectSnapshot(AuthState.getUserProfile).eid;
    }
    downloadImage(imageData) {
        const title = this.model.title || 'snapshot';
        const normalizedTitle = title.replace(/ /g, '_').replace(/\W/g, '');
        const fileName = `${normalizedTitle}.jpeg`;
        this.publishService.exportImage(imageData, ImageTypeEnum.JPEG, fileName)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((success) => {
            this.snackBar.open(success ? `Successfuly download image` : `Unable to download image.`);
        });
    }
}
__decorate([
    Select(PublishState.getDimensions),
    __metadata("design:type", Observable)
], PublishComponent.prototype, "dimensions$", void 0);
__decorate([
    Select(PublishState.getMinDimensions),
    __metadata("design:type", Observable)
], PublishComponent.prototype, "minDimensions$", void 0);
